/* eslint-disable no-magic-numbers -- surface tokens are named by number */

import styled, { keyframes, css } from 'styled-components';
import { Button, ButtonVariant } from '../button';

const fadeIn = keyframes`
	from {
		opacity: 0;
		transform: translateY(30px);
	}
	to {
		opacity: 1;
		transform: translateY(0);
	}
`;

const fadeOut = keyframes`
	from {
		opacity: 1;
		transform: translateY(0);
	}
	to {
		opacity: 0;
		transform: translateY(30px);
	}
`;

export const ActionBarWrapper = styled.div`
	position: fixed;
	bottom: 20px;
	left: 50%;
	transform: translateX(-50%);
	min-width: 300px;
	max-width: 700px;
	z-index: 1000;
`;

export const ActionBarAnimationWrapper = styled.div<{ $isExiting?: boolean }>`
	background: ${({ theme }) => theme.surface[4]};
	border-radius: 30px;
	padding: 16px 24px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 12px;
	box-shadow: ${({ theme }) => theme.shadow.inset};
	animation: ${fadeIn} ${({ theme }) => theme.motion.duration.default}
		${({ theme }) => theme.motion.easing.default};
	${({ $isExiting, theme }) => $isExiting && css`
		animation: ${fadeOut} ${theme.motion.duration.default}
			${theme.motion.easing.default} forwards;
	`}
`;

export const ActionBarContent = styled.div`
	display: flex;
	align-items: center;
	gap: 12px;
`;

export const ContentWrap = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: 4px;
`;

export const Divider = styled.div`
	height: 15px;
	width: 4px;
	background: ${({ theme }) => theme.border.decorative};
	border-radius: 3px;
	margin-left: 12px;
	margin-right: 12px;
	display: inline-block;
`;

export const Text = styled.p`
	color: ${({ theme }) => theme.text.primary};
	font-size: 14px;
	margin: 0;
`;

export const CloseButton = styled.button`
	background: none;
	border: none;
	cursor: pointer;
	padding: 4px;
	color: ${({ theme }) => theme.text.primary};
	display: flex;
	align-items: center;
`;

export const StyledButton = styled(Button)<{ $variant: ButtonVariant }>`
	variant: ${({ $variant }) => $variant};
	border-radius: 4px;
	background: transparent;
	color: ${({ theme }) => theme.text.primary};
	border: none;

	// Destructive actions keep their own hover; everything else lifts a surface step.
	&:hover {
		background: ${({ $variant, theme }) => $variant === 'danger' ? theme.fill.danger : theme.fill.dimmed};
		color: ${({ $variant, theme }) => $variant === 'danger' ? theme.text.danger : theme.text.primary};
		border: none;
		.icon {
			color: ${({ $variant, theme }) => $variant === 'danger' ? theme.text.danger : theme.text.primary};
		}
	}
	.icon {
		color: ${({ theme }) => theme.text.primary};
	}
`;
